import { createContext } from "react";

let init;
 export const LangContext = createContext(init);